import { graphql, useStaticQuery } from "gatsby"
import React from "react"
import { parseHTML } from "../../common/utils/utils"
import CTALink from "../elements/CTALink"
import "./AppraisalCard.scss"
import Animation from "../elements/Animation"

const NewAppraisalCard = ({executeRegisterFormScroll}) => {
  const data = useStaticQuery(graphql`
    query {
      allStrapiGlobalModule {
        edges {
          node {
            ...NewAppraisalFragment
          }
        }
      }
    }
  `)

  const appraisalData =
    data?.allStrapiGlobalModule.edges[0]?.node.new_property_valuation
    

  const { cta, title } = appraisalData
  return (
    <Animation className="appraisal-card">
      <div className="title">{parseHTML(title?.data?.title)}</div>
      {/* <CTALink
        cta={cta}
        className={"button button-white-outline appraisal-cta"}
      /> */}
       <button 
                onClick={executeRegisterFormScroll}
                className="button button-white-outline appraisal-cta"
              >
                <span>{cta.cta_label}</span> 
              </button>
    </Animation>
  )
}

export default NewAppraisalCard
